export const productColumnOptions = [
  {
    field: "Référence",
    description: "Identifiant unique pour le produit/service",
    example: "PROD001, SRV-ABC, REF123",
    required: true,
    category: "basic",
  },
  {
    field: "Nom",
    description: "Nom du produit ou service",
    example: "Consultation IT, Ordinateur portable, Licence logicielle",
    required: true,
    category: "basic",
  },
  {
    field: "Description",
    description: "Description détaillée du produit/service",
    example: "Service de consultation en informatique, Ordinateur professionnel haute performance",
    required: false,
    category: "basic",
  },
  {
    field: "Référence de catégorie  ( Famille produits / services )",
    description: "Référence de la catégorie du produit (doit exister)",
    example: "CAT001, CAT002",
    required: true,
    category: "basic",
  },
  {
    field: "Catégorie de l'exploitation",
    description: "Référence de la catégorie de l'exploitation - utiliser les codes exacts affichés",
    example: "bien, service, les deux",
    options: [
      { code: "bien", label: "Bien" },
      { code: "service", label: "Service" },
      { code: "les deux", label: "Les deux" },
    ],
    required: true,
    category: "basic",
  },
  {
    field: "Type d'article",
    description: "Type d'article du produit - utiliser les codes exacts affichés",
    options: [
      { code: "VTS", label: "Vente de prestations - services" },
      { code: "TR", label: "Travaux réalisés" },
      { code: "PF", label: "Produits finis" },
      { code: "PORT", label: "Frais de port" },
      { code: "EMB", label: "Emballages" },
      { code: "VTM", label: "Vente de marchandises" },
    ],
    example: "VTS, TR, PF, PORT, EMB, VTM",
    required: true,
    category: "basic",
  },
  {
    field: "Code unité de mesure",
    description: "Code de l'unité de mesure",
    example: "U, kg, l, h, m",
    options: [
      { code: "a", label: "are" },
      { code: "ca", label: "centiare" },
      { code: "cm", label: "centimètre" },
      { code: "ha", label: "hectare" },
      { code: "km", label: "kilomètre" },
      { code: "m2", label: "mètre carré" },
      { code: "ml", label: "mètre linéaire" },
      { code: "m", label: "mètre" },
      { code: "mm", label: "millimètre" },
      { code: "%", label: "pourcent" },
      { code: "u", label: "unitaire" },
      { code: "année", label: "année" },
      { code: "h", label: "heure" },
      { code: "j", label: "jour" },
      { code: "mois", label: "mois" },
      { code: "semaine", label: "semaine" },
      { code: "trimestre", label: "trimestre" },
      { code: "l", label: "litre" },
      { code: "m3", label: "mètre cube" },
      { code: "mil", label: "millilitre" },
      { code: "g", label: "gramme" },
      { code: "kg", label: "kilogramme" },
      { code: "t", label: "tonne" },
      { code: "f", label: "forfait" },
    ],
    required: true,
    category: "pricing",
  },
  {
    field: "Taux de TVA",
    description:
      "Taux de TVA applicable - accepte des valeurs comme 10%, 0.1, 25%, 0.25. Assurez-vous que le taux de TVA avec ce pourcentage existe dans les paramètres comptables tableau TVA",
    example: "10%, 0.1, 25%, 0.25",
    required: false,
    category: "pricing",
  },

  {
    field: "Prix unitaire HT",
    description: "Prix unitaire hors taxes",
    example: "100.00, 250.50",
    required: false,
    category: "pricing",
  },
  {
    field: "Prix d'achat",
    description: "Prix d'achat unitaire",
    example: "80.00, 200.00",
    required: false,
    category: "pricing",
  },
];
